import React, { Fragment, useEffect, useRef, useState } from "react";
// import HomeIcon from "@mui/icons-material/Home";
import { Button, Portal } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import EqualizerIcon from "@mui/icons-material/Equalizer";
import { Link, useLocation } from "react-router-dom";
import { Analytics, Settings } from "@mui/icons-material";
import { RiOrderPlayFill } from "react-icons/ri";
import BusinessCenterIcon from "@mui/icons-material/BusinessCenter";
import QrCodeScannerIcon from "@mui/icons-material/QrCodeScanner";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import AirlineStopsIcon from "@mui/icons-material/AirlineStops";
import PointOfSaleIcon from "@mui/icons-material/PointOfSale";
import HourglassBottomIcon from "@mui/icons-material/HourglassBottom";
import AssessmentIcon from "@mui/icons-material/Assessment";
import StorefrontIcon from "@mui/icons-material/Storefront";
import InventoryIcon from "@mui/icons-material/Inventory";
import SummarizeIcon from "@mui/icons-material/Summarize";
import ViewQuiltIcon from "@mui/icons-material/ViewQuilt";
import RuleIcon from "@mui/icons-material/Rule";
import { getEnvironment } from "../../Middleware/CommonFun";
import secureLocalStorage from "react-secure-storage";

let uri = secureLocalStorage.getItem("BaseURI");
const environment = getEnvironment(uri);

const SIDEBAR_ARR = [
  {
    id: 1,
    title: "Manufacturing Packaging",
    icon: <BusinessCenterIcon />,
    uri: "/",
  },
  {
    id: 2,
    title: "Basic Quality",
    icon: <EqualizerIcon />,
    uri: "/qualitymanager/basic-quantity",
  },
  {
    id: 6,
    title: "Master Data",
    icon: <EqualizerIcon />,
    uri: "/qualitymanager/master-data",
  },
  {
    id: 4,
    title: "Manufacture Order",
    icon: <RiOrderPlayFill size={19} />,
    uri: "/manufacture-cutting",
  },

  {
    id: 17,
    title: "Multi User Manufacture Scan",
    icon: <RiOrderPlayFill size={19} />,
    uri: "/multiuser-manufacture-scan",
  },

  {
    id: 5,
    title: "Create Serial Code",
    icon: <QrCodeScannerIcon />,
    uri: "/create-serial-code",
  },
  {
    id: 7,
    title: "WIP Inventory Hold",
    icon: <AirlineStopsIcon />,
    uri: "/wip-inventory-hold",
  },
  {
    id: 10,
    title: "Retail",
    icon: <StorefrontIcon />,
    children: [
      {
        id: 8,
        title: "Production Consolidated Report",
        uri: "/product-consolidated-report",
        icon: <AssessmentIcon />,
      },
      {
        id: 9,
        title: "Hourly Production Report",
        uri: "/hourly-production-report",
        icon: <HourglassBottomIcon />,
      },
      {
        id: 11,
        title: "Suborder Summary",
        uri: "/suborder-summary",
        icon: <PointOfSaleIcon />,
      },
      {
        id: 12,
        title: "Temp Hold Inventory",
        uri: "/temp-hold-inventory",
        icon: <InventoryIcon />,
      },
      {
        id: 13,
        title: "Portal Net Inventory...",
        uri: "/portal-net-inventory-summary",
        icon: <SummarizeIcon />,
      },
      {
        id: 14,
        title: "Sub order Level View...",
        uri: "/suborder-local-view-consolidated",
        icon: <ViewQuiltIcon />,
      },
      {
        id: 15,
        title: "Sales Analysis",
        uri: "/sales-analysis",
        icon: <Analytics />,
      },
      {
        id: 16,
        title: "Inventory Missing List",
        uri: "/inventory-missing-list",
        icon: <RuleIcon />,
      },
    ],
  },

  {
    id: 3,
    title: "Settings",
    icon: <Settings />,
    uri: "/settings",
  },
];

const SideBar = ({ isOpened, handleSidebar }) => {
  const location = useLocation();

  const sidebarRef = useRef(null);

  const [openSubMenu, setOpenSubMenu] = useState(null);

  const toggleSubMenu = (id) => {
    setOpenSubMenu(openSubMenu === id ? null : id);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (sidebarRef.current && !sidebarRef.current.contains(event.target)) {
        handleSidebar(); // Close sidebar if clicked outside
      }
    };

    if (isOpened) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpened, handleSidebar]);
  return (
    <Fragment>
      <div
        ref={sidebarRef}
        className={`sidebar__container ${isOpened ? "sidebar__open" : ""}`}
      >
        <Button onClick={handleSidebar}>
          <CloseIcon />
        </Button>

        <h1>Production Module</h1>

        <div className="sidebar__flow__row">
          {SIDEBAR_ARR.map((item) => (
            <div className="sidebar__container__fluid" key={item.id}>
              {item.children ? (
                <div
                  className={`sidebar__row ${openSubMenu === item.id ? "active__sidebar" : ""
                    }`}
                  onClick={() => toggleSubMenu(item.id)}
                  style={{
                    cursor: "pointer",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "8px",
                    }}
                  >
                    {item.icon}
                    <span>{item.title}</span>
                  </div>
                  <ExpandMoreIcon
                    className={`chevron ${openSubMenu === item.id ? "rotate" : ""
                      }`}
                  />
                </div>
              ) : (
                <Link
                  to={item.uri}
                  className={`sidebar__row ${location.pathname === item.uri ? "active__sidebar" : ""
                    }`}
                >
                  <div>{item.icon}</div>
                  <div>{item.title}</div>
                </Link>
              )}

              {/* Submenu */}
              <div
                className={`submenu__wrapper ${openSubMenu === item.id ? "open" : ""
                  }`}
              >
                {item.children &&
                  item.children.map((subItem) => (
                    <Link
                      key={subItem.id}
                      to={subItem.uri}
                      className={`sidebar__row sidebar__submenu ${location.pathname === subItem.uri
                          ? "active__sidebar"
                          : ""
                        }`}
                    >
                      <div style={{ marginLeft: "0.5rem" }}>{subItem.icon}</div>
                      <div>{subItem.title}</div>
                    </Link>
                  ))}
              </div>
            </div>
          ))}
        </div>
      </div>
    </Fragment>
  );
};

export default SideBar;
